<template>
  <div class="menu">
    <div class="menu-logo"></div>
    <div class="menu-list my-scrollbar">
      <el-menu :default-active="defaultActive" class="my-menu" :router="true">
        <div v-for="(item, index) in menuList" :key="index">
          <el-submenu :index="item.id" v-if="item.children && item.children.length > 0">
            <template slot="title">
              <i class="icon-menu"><svg-icon :iconFileName="item.icon" /></i>
              <span class="span-title">
                {{ item.name }}
              </span>
            </template>
            <el-menu-item v-for="itemC in item.children" :key="itemC.id" :index="itemC.path">
              <template slot="title">
                <span class="span-title">
                    {{ itemC.name }}
                </span>
              </template>
            </el-menu-item>
          </el-submenu>
          <el-menu-item :index="item.path" v-else>
            <template slot="title">
              <i class="icon-menu"><svg-icon :iconFileName="item.icon" /></i>
              <span class="span-title">
                {{ item.name }}
              </span>
            </template>
          </el-menu-item>
        </div>
      </el-menu>
    </div>
  </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon'
export default {
  components: {
    SvgIcon
  },
  data() {
    return {
      defaultActive: '/Home/Store',
      menuList: [
        { id: '1', name: '门店信息', icon: 'store', path:'/Home/Store', children: []},
        { id: '2', name: '点播记录', icon: 'pointDeduction', path:'/Home/PointDeduction', children: [] },
        { id: '3', name: '充值记录', icon: 'recharge', path:'/Home/Recharge', children: [] },
        { id: '4', name: '运营统计查询', icon: 'operationsStatistics', path:'/Home/OperationsStatistics', children: [] },
        { id: '5', name: '门店运营分析', icon: 'storeOperationsChart', path:'/Home/StoreOperationsChart', children: [] },
        { id: '6', name: '游戏运营分析', icon: 'gameOperationsAnalysis', path:'/Home/GameOperationsAnalysis', children: [] },
      ],
    }
  },
  mounted() {
    this.defaultActive = this.$route.path
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.menu{
  width: 100%;
  height: 100%;
  .menu-logo{
    background: url(../assets/image/icon/menu-logo.png) no-repeat center;
  }
}
</style>